module.exports = __webpack_public_path__ + "img/app_screenshot.80654f2d.png";